// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3RX4s","flatButton":"Button_flatButton__3sb6A","ripple":"Button_ripple__1NBdR"};